import { __decorate, __metadata } from 'tslib';
import { EventEmitter, Input, Output, Component, NgModule } from '@angular/core';
import { UiBsTranslateService, UiBsTranslateModule } from '@wlp/ui-bs-translate';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { NgxMaskIonicModule } from 'ngx-mask-ionic';
import { UiCButtonModule } from '@wlp/ui-c-button';
import { UiCBoxRadiusModule } from '@wlp/ui-c-box-radius';
import { UiCUploadFileWebModule } from '@wlp/ui-c-upload-file-web';
import { UiCHeaderOnboardingModule } from '@wlp/ui-c-header-onboarding';
import { UiCCameraModule } from '@wlp/ui-c-camera';
import { AngularSvgIconModule } from 'angular-svg-icon';

let UiCDocumentTypeComponent = class UiCDocumentTypeComponent {
    constructor(translate) {
        this.translate = translate;
        this.items = null;
        this.isPhoto = false;
        this.isUpload = false;
        this.isBack = true;
        this.isMobile = false;
        this.isModal = false;
        this.isOnboardingV2Flow = false;
        this.hasImage = false;
        this.document = new EventEmitter();
        this.position = new EventEmitter();
        this.remove = new EventEmitter();
        this.uploadFile = new EventEmitter();
        this.alertLarger = new EventEmitter();
        this.back = new EventEmitter();
        this.continue = new EventEmitter();
        this.viewFileEvent = new EventEmitter();
    }
    ngOnInit() {
        console.log(this.getImageTag);
    }
    changeTextDescription(data) {
        let title = '';
        /* if (data.isTwoSides) {
          if (data.position === 'FRONT') {
            title = 'ONBORDING.V2.FORM.LABEL.FRONT';
          } else if (data.position === 'VERSE') {
            title = 'ONBORDING.V2.FORM.LABEL.VERSE';
          }
        } */
        if (!data.requiredFile) {
            if (title !== '') {
                title = title + '_OPTIONAL';
            }
            else {
                title = 'ONBORDING.V2.FORM.LABEL.OPTIONAL';
            }
        }
        return title;
    }
    changeDocument(event) {
        this.fileDocument = event;
        this.file = null;
        if (event.items) {
            this.items = event.items;
            return;
        }
        this.document.emit(event);
        this.isUpload = true;
    }
    removeFile() {
        this.file = null;
        this.remove.emit();
    }
    getUploadFile(event) {
        this.file = event;
        this.uploadFile.emit({ data: event, isPhoto: this.isPhoto, isUpload: this.isUpload });
    }
    getUploadPhoto(event) {
        this.isUpload = !this.isUpload;
        this.file = event;
        this.uploadFile.emit({ data: event, isPhoto: this.isPhoto, isUpload: this.isUpload });
    }
    alertDocumentLarge() {
        this.alertLarger.emit();
    }
    goBack() {
        if (this.isPhoto) {
            if (this.isModal) {
                document.getElementById('page-partners').classList.remove('off');
                document.getElementsByClassName('modal-partner-upload').item(0).classList.remove('off-modal');
            }
            document.getElementById('container-onboarding').style.backgroundImage = this.backgroundImage;
            document.getElementById('logo-onboarding').classList.remove('off');
            this.isPhoto = false;
            return;
        }
        if (this.isUpload) {
            this.isUpload = false;
            return;
        }
        if (this.items) {
            this.items = null;
            return;
        }
        this.back.emit();
    }
    goContinue(next) {
        if (this.isPhoto) {
            if (this.isModal) {
                document.getElementById('page-partners').classList.remove('off');
                document.getElementsByClassName('modal-partner-upload').item(0).classList.remove('off-modal');
            }
            document.getElementById('container-onboarding').style.backgroundImage = this.backgroundImage;
            document.getElementById('logo-onboarding').classList.remove('off');
        }
        if (this.file || next) {
            this.items = null;
            this.isPhoto = false;
            this.isUpload = false;
            this.continue.emit(this.name);
        }
    }
    changeTypeUpload() {
        this.isUpload = !this.isUpload;
        this.isPhoto = !this.isPhoto;
        if (this.isPhoto) {
            if (this.isModal) {
                document.getElementById('page-partners').classList.add('off');
                document.getElementsByClassName('modal-partner-upload').item(0).classList.add('off-modal');
            }
            this.backgroundImage = document.getElementById('container-onboarding').style.backgroundImage;
            document.getElementById('container-onboarding').style.backgroundImage = 'none';
            document.getElementById('container-onboarding').style.backgroundColor = 'transparent';
            document.getElementById('logo-onboarding').classList.add('off');
        }
        else if (!this.isPhoto) {
            if (this.isModal) {
                document.getElementById('page-partners').classList.remove('off');
                document.getElementsByClassName('modal-partner-upload').item(0).classList.remove('off-modal');
            }
            document.getElementById('logo-onboarding').classList.remove('off');
            document.getElementById('container-onboarding').style.backgroundImage = this.backgroundImage;
            document.getElementById('container-onboarding').style.backgroundColor = this.backgroundImage;
        }
    }
    validadandoTipoDoc(file) {
        if (file.document === "RG" || file.document === "RESIDENCIAL_CERTIFICATE") {
            return 'true';
        }
        else {
            return 'false';
        }
    }
    preprareDescriptionUpload(file) {
        if (file.document === "RG") {
            if (file.position === 'FRONT') {
                return `${file.document} - ${this.translate.applyTranslate('ONBORDING.V2.FORM.LABEL.FRONT')}`;
            }
            else if (file.position === 'VERSE') {
                return `${file.document} - ${this.translate.applyTranslate('ONBORDING.V2.FORM.LABEL.VERSE')}`;
            }
        }
        else if ((this.isPhysicalPerson || this.isLiberalPersonalType || this.isMei) && file.document === 'RESIDENCIAL_CERTIFICATE') {
            return this.translate.applyTranslate('ONBORDING.DOCUMENT_TYPE.BUTTON_TEXT.RESIDENTIAL_CERTIFICATE.MESSAGE_PHYSICAL');
        }
        else if ((!this.isLiberalPersonalType && !this.isPhysicalPerson && !this.isMei) && file.document === 'RESIDENCIAL_CERTIFICATE') {
            return this.translate.applyTranslate('ONBORDING.DOCUMENT_TYPE.BUTTON_TEXT.RESIDENTIAL_CERTIFICATE.MESSAGE');
        }
        return '';
    }
    isMenuSendFile(file, platform) {
        if (platform == 'app') {
            return file.document != "SELF_PHOTO";
        }
        if (platform == 'web') {
            return file.document == "SELF_PHOTO";
        }
    }
    /* changeText(file: any) {
      if (this.isPhysicalPerson && file.document === 'RESIDENCIAL_CERTIFICATE') {
        return this.translate.applyTranslate('ONBORDING.DOCUMENT_TYPE.BUTTON_TEXT.RESIDENTIAL_CERTIFICATE.MESSAGE_PHYSICAL');
      } else return ''
    } */
    clickView() {
        this.viewFileEvent.emit();
    }
};
__decorate([
    Input(),
    __metadata("design:type", Object)
], UiCDocumentTypeComponent.prototype, "items", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], UiCDocumentTypeComponent.prototype, "isBack", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], UiCDocumentTypeComponent.prototype, "isMobile", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], UiCDocumentTypeComponent.prototype, "isModal", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCDocumentTypeComponent.prototype, "name", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCDocumentTypeComponent.prototype, "title", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCDocumentTypeComponent.prototype, "description", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], UiCDocumentTypeComponent.prototype, "listDocuments", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], UiCDocumentTypeComponent.prototype, "requiredFile", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], UiCDocumentTypeComponent.prototype, "visible", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCDocumentTypeComponent.prototype, "primaryColor", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCDocumentTypeComponent.prototype, "secondaryColor", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], UiCDocumentTypeComponent.prototype, "isPhysicalPerson", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], UiCDocumentTypeComponent.prototype, "isLiberalPersonalType", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], UiCDocumentTypeComponent.prototype, "isMei", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCDocumentTypeComponent.prototype, "platform", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], UiCDocumentTypeComponent.prototype, "isOnboardingV2Flow", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], UiCDocumentTypeComponent.prototype, "hasImage", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCDocumentTypeComponent.prototype, "getImageTag", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCDocumentTypeComponent.prototype, "document", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCDocumentTypeComponent.prototype, "position", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCDocumentTypeComponent.prototype, "remove", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCDocumentTypeComponent.prototype, "uploadFile", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCDocumentTypeComponent.prototype, "alertLarger", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCDocumentTypeComponent.prototype, "back", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCDocumentTypeComponent.prototype, "continue", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCDocumentTypeComponent.prototype, "viewFileEvent", void 0);
UiCDocumentTypeComponent = __decorate([
    Component({
        selector: 'ui-c-document-type',
        template: "<ng-container *ngIf=\"!isUpload && !isPhoto\">\n  <div class=\"animation-type\">\n    <ui-c-header-onboarding [isBack]=\"isBack\" [isText]=\"listDocuments.length >= 1\"\n      [textBack]=\"'ONBORDING.V2.BUTTON.BACK' | wlpTranslate\" [title]=\"title | wlpTranslate\"\n      [description]=\"description | wlpTranslate\" [primaryColor]=\"primaryColor\" [secondaryColor]=\"secondaryColor\"\n      (back)=\"goBack()\">\n    </ui-c-header-onboarding>\n\n    <ng-container *ngIf=\"visible && listDocuments.length > 0\">\n      <ion-row class=\"ion-justify-content-center ion-align-items-center pl-3 pr-3 upload-documents-responsive\"\n        *ngIf=\"!items\">\n        <ion-col class=\"animation-document upload-document-card-responsive\" [sizeXs]=\"6\" [sizeSm]=\"4\"\n          [sizeMd]=\" isModal ? 4:2\" [size]=\" isModal ? 4:2\" *ngFor=\"let document of listDocuments\"\n          (click)=\"changeDocument(document)\">\n          <ui-c-box-radius [class]=\"document?.imageTag \"\n            [textTitle]=\"preprareDescriptionUpload(document) != '' ? preprareDescriptionUpload(document) : document.text | wlpTranslate\"\n            [textDescription]=\"changeTextDescription(document) | wlpTranslate\" titlePosition=\"bottom\">\n          </ui-c-box-radius>\n        </ion-col>\n      </ion-row>\n      <ng-container *ngIf=\"items\">\n        <div *ngFor=\"let item of items; let i = index;\">\n          <ion-row class=\"ion-justify-content-center ion-align-items-center\" *ngIf=\"i !== 0\">\n            <ion-col class=\"animation-document\" size=\"12\">\n              <h3 class=\"font-size-18 font-family-bold color-primary text-center\">\n                {{ 'ONBORDING.V2.TEXT.TITLE.OR' | wlpTranslate }}\n              </h3>\n            </ion-col>\n          </ion-row>\n          <ion-row class=\"ion-justify-content-center ion-align-items-center upload-documents-responsive\">\n            <ion-col class=\"animation-document\" [sizeXs]=\"8\" [sizeSm]=\"8\" [sizeMd]=\" isModal ? 4:2\"\n              [size]=\" isModal ? 4:2\" *ngFor=\"let document of item\" (click)=\"changeDocument(document)\">\n              <ui-c-box-radius [class]=\"document?.imageTag\"\n                [textTitle]=\"preprareDescriptionUpload(document) != '' ? preprareDescriptionUpload(document) : document.text | wlpTranslate\"\n                [textDescription]=\"changeTextDescription(document) | wlpTranslate\" titlePosition=\"bottom\">\n              </ui-c-box-radius>\n            </ion-col>\n          </ion-row>\n        </div>\n      </ng-container>\n\n      <ion-row class=\"ion-justify-content-center margin-button ion-margin-top ion-margin-bottom\" *ngIf=\"!requiredFile\">\n        <ion-col [size]=\"12\" [sizeMd]=\"4\" [sizeSm]=\"4\" class=\"teste\">\n          <ui-c-button expand=\"block\" (continue)=\"goContinue(true)\">\n            {{ 'ONBORDING.V2.BUTTON.NEXT' | wlpTranslate }}\n          </ui-c-button>\n        </ion-col>\n      </ion-row>\n    </ng-container>\n\n    <ng-container *ngIf=\"visible && listDocuments.length < 1 && !isOnboardingV2Flow\">\n      <ion-row class=\"d-flex h-75 mt-4 flex-column ion-justify-content-center ion-align-items-center\">\n        <h2 class=\"ion-text-center font-family-semibold\" style=\"margin: auto;\">\n          <span class=\"document-complete color-primary font-family-bold\" [style.color]=\"primaryColor\">\n            {{ 'ONBORDING.V2.TEXT.TITLE.DOCUMENT_COMPLETE' | wlpTranslate }}\n          </span>\n        </h2>\n        <ion-row class=\"d-flex justify-content-center w-100 mt-4 go-next-button-uploaded\" style=\"margin: auto;\">\n          <ion-col [size]=\"12\" [sizeMd]=\"4\" [sizeSm]=\"4\">\n            <ui-c-button expand=\"block\" (continue)=\"goContinue(true)\" class=\"next-button-upload-docs-responsive\">\n              {{ 'ONBORDING.V2.BUTTON.NEXT' | wlpTranslate }}\n            </ui-c-button>\n          </ion-col>\n        </ion-row>\n      </ion-row>\n    </ng-container>\n\n    <ng-container *ngIf=\"visible && listDocuments.length < 1 && isOnboardingV2Flow\">\n      <ion-row class=\"d-flex flex-column ion-justify-content-center ion-align-items-center pl-3 pr-3\">\n        <div class=\"document-uploaded\">\n          <div *ngIf=\"hasImage\">\n            <svg-icon \n              [stretch]=\"false\" \n              [src]=\"getImageTag\"\n            ></svg-icon>\n          </div>\n\n          <div class=\"mt-2 mb-4\">\n            <h1 class=\"font-size-24 ion-text-center font-family-bold\" [style.color]=\"primaryColor\">Uploads Finalizado</h1>\n            <p class=\"font-size-14 document-complete ion-text-center font-family-semibold\" [style.color]=\"'#DADBDC'\">\n              {{ 'ONBORDING.V2.TEXT.TITLE.DOCUMENT_COMPLETE' | wlpTranslate }}\n            </p>\n          </div>\n        </div>\n\n        <div>\n          <ui-c-button expand=\"block\" (continue)=\"goContinue(true)\">\n            {{ 'ONBORDING.V2.BUTTON.NEXT' | wlpTranslate }}\n          </ui-c-button>\n        </div>\n      </ion-row>\n    </ng-container>\n  </div>\n</ng-container>\n\n<ng-container *ngIf=\"isUpload\">\n  <div class=\"animation-type\">\n    <ui-c-header-onboarding [isBack]=\"isBack\" [textBack]=\"'ONBORDING.V2.BUTTON.BACK' | wlpTranslate\"\n      [title]=\"'ONBORDING.V2.TEXT.TITLE.DOCUMENT_UPLOAD' | wlpTranslate\"\n      [description]=\"preprareDescriptionUpload(fileDocument) != '' ? preprareDescriptionUpload(fileDocument) : fileDocument.text | wlpTranslate\"\n      [primaryColor]=\"primaryColor\" [secondaryColor]=\"secondaryColor\" (back)=\"goBack()\">\n    </ui-c-header-onboarding>\n\n    <ion-row class=\"ion-justify-content-center ion-align-items-center pr-3 pl-3\">\n      <ion-col [size]=\"12\" [sizeMd]=\"12\" [sizeSm]=\"8\" class=\"animation-document next-button-upload-docs-responsive\">\n        <ui-c-upload-file-web class=\"upload-file\" [platform]=\"platform\"\n          [isFileSend]=\"isMenuSendFile(fileDocument, platform)\" [sizeFile]=\"5242880\" (viewFileEvent)=\"clickView()\"\n          [subTitle]=\"'ONBORDING.V2.TEXT.TITLE.MAX_FILE' | wlpTranslate\" (goRemoveFile)=\"removeFile()\"\n          (getFile)=\"getUploadFile($event)\" (burst)=\"alertDocumentLarge()\">\n        </ui-c-upload-file-web>\n      </ion-col>\n    </ion-row>\n\n    <ion-row class=\"ion-justify-content-center margin-button\">\n      <ion-col [size]=\"12\" [sizeMd]=\"4\" [sizeSm]=\"4\" *ngIf=\"!file && isMobile\">\n        <ui-c-button expand=\"block\" (continue)=\"changeTypeUpload()\">\n          {{ 'ONBORDING.V2.BUTTON.PHOTO' | wlpTranslate }}\n        </ui-c-button>\n      </ion-col>\n      <ion-col [size]=\"12\" [sizeMd]=\"4\" [sizeSm]=\"4\" class=\"next-button-upload-docs-responsive go-next-button\">\n        <ui-c-button [disabled]=\"!file\" expand=\"block\" (continue)=\"goContinue()\">\n          {{ 'ONBORDING.V2.BUTTON.NEXT' | wlpTranslate }}\n        </ui-c-button>\n      </ion-col>\n    </ion-row>\n  </div>\n</ng-container>\n\n<ng-container *ngIf=\"isPhoto\">\n  <ui-c-camera *ngIf=\"isPhoto\"\n    typeQuestion=\"{{(fileDocument.document !== 'SELF_PHOTO' ? 'ONBORDING.V2.TEXT.TITLE.PHOTO' : 'ONBORDING.V2.TEXT.TITLE.SELF_PHOTO') | wlpTranslate}}\"\n    titleHeader=\"{{(validadandoTipoDoc(fileDocument) === 'true' ? preprareDescriptionUpload(fileDocument) : fileDocument?.text) | wlpTranslate}}\"\n    [typePhoto]=\"fileDocument.document == 'SELF_PHOTO' ? 'selfie' : 'template'\"\n    [selfieCamera]=\"fileDocument.document == 'SELF_PHOTO'\" class=\"camera-preview\" (goBack)=\"changeTypeUpload()\"\n    (photo)=\"getUploadPhoto($event)\"></ui-c-camera>\n</ng-container>\n"
    }),
    __metadata("design:paramtypes", [UiBsTranslateService])
], UiCDocumentTypeComponent);

let UiCDocumentTypeModule = class UiCDocumentTypeModule {
};
UiCDocumentTypeModule = __decorate([
    NgModule({
        declarations: [UiCDocumentTypeComponent],
        imports: [
            CommonModule,
            ReactiveFormsModule,
            NgxMaskIonicModule,
            IonicModule,
            UiBsTranslateModule,
            FormsModule,
            UiCButtonModule,
            UiCBoxRadiusModule,
            UiCUploadFileWebModule,
            UiCHeaderOnboardingModule,
            UiCCameraModule,
            AngularSvgIconModule.forRoot()
        ],
        exports: [UiCDocumentTypeComponent]
    })
], UiCDocumentTypeModule);

export { UiCDocumentTypeComponent, UiCDocumentTypeModule };
//# sourceMappingURL=wlp-ui-c-document-type.js.map
